<template>
     <div class="container-fluid mt-5">
         <h1>Blog</h1>
         <div class="row">
             <div class="col-md-3 col-sm-12" v-for="blog of blogs" :key="blog.id">
                 <div class="card">
                     <div class="card-body">
                         <h5 class="card-title">{{ blog.title }}</h5>
                         <p class="card-text">
                             <img :src="`data:image/jpg;base64,${blog.images[0].picture}`" :alt="blog.title" class="img-fluid">
                         </p>
                         <router-link :to="{name: 'BlogShow', params: { slug: blog.slug }}" class="btn btn-primary">Read</router-link>
                     </div>
                 </div>
             </div>
         </div>
     </div>
</template>

<script>
    export default {
        name: "Blog",
        data() {
            return {
                blogs:[]
            }
        },
        created() {
            this.fetchData()
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_BLOG_API}/news?size=50`)
                .then(response => {
                    this.blogs = response.data.content
                })
            }
        }
    }
</script>

<style scoped>

</style>
